import type { MarkerLocationProps } from "./marker-location.type";

import { scaleMarkerLocationSize } from "./marker-location.helper";

import "./marker-location.style.less";

const MarkerLocation = ({ scale }: MarkerLocationProps) => {
  const { width, height } = scaleMarkerLocationSize(scale);
  return (
    <svg
      viewBox="0 0 35 40"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className="marker-location"
    >
      <path
        fill="#fff"
        d="M17.5,0c-2.4,0-4.7.5-6.8,1.4-2.1.9-4,2.1-5.6,3.7-1.6,1.6-2.9,3.5-3.7,5.6-.9,2.2-1.4,4.5-1.4,6.8s.5,4.7,1.4,6.8c.9,2.1,2.1,4,3.7,5.6,1.6,1.6,12.4,9.8,12.4,9.8,0,0,10.8-8.2,12.4-9.8,1.6-1.6,2.9-3.5,3.7-5.6.9-2.2,1.4-4.5,1.4-6.8s-.5-4.7-1.4-6.8c-.9-2.1-2.1-4-3.7-5.6-1.6-1.6-3.5-2.9-5.6-3.7-2.2-.9-4.5-1.4-6.8-1.4h0Z"
      />
      <path
        fill="#008cff"
        d="M17.5,2.6c-8.3,0-15,6.7-15,15s6.7,15,15,15,15-6.7,15-15S25.8,2.6,17.5,2.6ZM22,22.1c-1.2,1.2-2.8,1.9-4.5,1.9-1.7,0-3.3-.7-4.5-1.9-1.2-1.2-1.9-2.8-1.9-4.5,0-1.7.7-3.3,1.9-4.5,1.2-1.2,2.8-1.9,4.5-1.9s3.3.7,4.5,1.9,1.9,2.8,1.9,4.5-.7,3.3-1.9,4.5Z"
      />
    </svg>
  );
};

export default MarkerLocation;
